<template>
  <b-modal ref="modal-exclude-bill-reward" title="Nhập từ excel" size="lg">
    <div class="row">
      <div class="col-md-12">
        <ExcelImport
          :url-excel="urlExcel"
          :cancel-route="'/reward-programs'"
          :uploading="uploading"
          :file="file"
          :disabled="hasValidationErrors"
          :hide-wrapper="true"
          @file-select="handleFileSelect"
          @clear-file="handleClearFile"
        >
          <template #table>
            <ExcelImportListTable
              table-title="Danh sách hoá đơn không được tính thưởng từ file excel"
              :items="importItems"
              :fields="fields"
              :uploading="uploading"
              :valid-count="validCount"
              :invalid-count="invalidCount"
              :current-page="currentPage"
              @update:currentPage="currentPage = $event"
            />
          </template>
        </ExcelImport>
      </div>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="hideModal">Hủy</b-button>
      <SaveButton
        :is-busy="uploading"
        :disabled="!canSave"
        @click="handleSubmit"
      />
    </template>
  </b-modal>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ExcelImport from '@/view/components/common/ExcelImport.vue';
import ExcelImportListTable from '@/view/components/common/ExcelImportListTable.vue';
import excelImportMixin from '@/view/mixins/excel-import.mixin';
import { URL_IMPORT_EXCLUDE_BILL_REWARD } from '@/utils/constants';
import SaveButton from '@/view/components/common/SaveButton.vue';

export default {
  name: 'ModelImportExcelExcludeBillReward',
  mixins: [excelImportMixin],
  components: {
    ExcelImport,
    ExcelImportListTable,
    SaveButton,
  },
  data() {
    return {
      urlExcel: URL_IMPORT_EXCLUDE_BILL_REWARD,
      rewardProgramId: null,
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'billNumber',
          label: 'Mã hoá đơn',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '20%',
          },
          tdClass: 'text-right',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'errors',
          label: 'Chi tiết',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-left',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Chương trình thưởng hoa hồng', route: '/reward-programs' },
      {
        title: 'Thêm mới chương trình thưởng hoa hồng',
        route: '/reward-programs',
      },
      { title: 'Nhập hoá đơn không được tính thưởng excel' },
    ]);
  },
  methods: {
    mapExcelDataToItems(excelData) {
      return excelData.map((element) => ({
        billNumber: element['Mã hoá đơn'],
        isValid: true,
        errors: [],
      }));
    },
    getValidationEndpoint() {
      return 'v1/reward-programs/validate-exclude-bill-reward';
    },
    getValidationPayload(importItems) {
      return {
        excludeBillReward: importItems.map((item) => ({
          billNumber: Number(item.billNumber),
        })),
      };
    },
    getSubmitEndpoint() {
      return null;
    },
    handleSubmit() {
      const listBillNumber = this.importItems
        .filter((item) => item.isValid)
        .map((item) => Number(item.billNumber));

      const excludeBillReward = {
        listBillNumber,
      };

      this.$emit('update-exclude-bill-rewards', excludeBillReward);
      this.hideModal();
      this.clearFiles();
    },
    getSubmitPayload() {
      return {
        excludeBillReward: this.importItems
          .filter((item) => item.isValid)
          .map((item) => ({
            billNumber: Number(item.billNumber),
          })),
      };
    },
    handleClearFile() {
      this.clearFiles();
    },
    hideModal() {
      this.$refs['modal-exclude-bill-reward'].hide();
    },
    showModal(rewardProgramId = null) {
      this.rewardProgramId = rewardProgramId;
      this.$refs['modal-exclude-bill-reward'].show();
    },
  },
  computed: {
    canSave() {
      return this.importItems.every((item) => item.isValid);
    },
  },
};
</script>
